import { Link } from "react-router-dom";
import type { SchoolClass } from "../lib/data.js";
import own from "./ClassTable.module.css";
import shell from "../../../shared/components/shell.module.css";

export function ClassTable({ classes }: { classes: readonly SchoolClass[] }) {
  return (
    <table className={shell.wide}>
      <thead>
        <tr>
          <th>Klasse</th>
          <th>Schuljahr</th>
          <th className={`${own.courses} ${shell.stretch}`}>Lehrgang</th>
          <th className={own.count}>Übungscodes</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {classes.map((schoolClass) => (
          <tr key={schoolClass.id}>
            <td>
              <strong>{schoolClass.name}</strong>
            </td>
            <td>{schoolClass.schoolYear}</td>
            {/* Die Fassung steht hier bewusst nicht: sie ist eine Angabe über
                den Inhalt, der Lehrgang eine über die Klasse. */}
            <td className={`${own.courses} ${shell.stretch}`}>
              {schoolClass.courses.join(" · ") || "–"}
            </td>
            <td className={own.count}>{schoolClass.codeCount}</td>
            {/* Drei Wege in dieselbe Klasse, und sie führen zu drei
                verschiedenen Vorgängen: Kärtchen drucken, Ergebnisse ansehen,
                Lehrgänge einrichten. Vorher gab es einen Weg, und die
                Codeseite trug alle drei – die Ergebnisse als Verweis, die
                Lehrgänge als dritte Karte darunter. */}
            <td className={own.links}>
              <Link to={`/classes/${schoolClass.id}/codes`}>Übungscodes</Link>
              <Link to={`/classes/${schoolClass.id}/results`}>Ergebnisse</Link>
              <Link to={`/classes/${schoolClass.id}/settings`}>Einstellungen</Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
